import { connect } from 'react-redux'
import get from 'lodash/get'

import {
  selectReport as onSelectReport
} from '../../actions/selectedReportsActions'

const mapStateToProps = (state) => ({
  selectedReports: get(state, ['selectedReports', 'data'], [])
})

const mapDispatchToProps = {
  onSelectReport
}

const withSelectedReports = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withSelectedReports }